import {
  Bestellung,
  CheckoutOrder,
  RemoteResult,
  CheckoutRequest,
  LoadState,
} from "mangdto"
import router from "@/router"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"

export default class BezahlenLogic extends BaseLogic {
  bestellung: Bestellung = null
  checkoutLoadState: LoadState = LoadState.Idle

  init() {
    this.bestellung = this.mainLogic.bestellung
  }

  weiter() {
    this.checkoutLoadState = LoadState.Loading

    var request = new CheckoutRequest()
    request.id = this.bestellung.id
    request.checkoutMode = 1

    Poster.postUser<RemoteResult<CheckoutOrder>>(
      RestPaths.paymentPaypalCheckout,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.checkoutLoadState = LoadState.Completed
          window.location.href =
            "https://www.sandbox.paypal.com/checkoutnow?token=" +
            response.data.payload.orderId
        } else {
          this.checkoutLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.checkoutLoadState = LoadState.Error
      })
  }

  weiterTrinkgeld() {
    router.push({ name: RouteNames.BESTELLUNG_PAGE.TRINKGELD })
  }
}
